export const DEFAULT_MINUTES_TO_REOPEN_KIOSK = 20;

export const DEFAULT_SCREENSAVER_PERIOD = 'PT20S';
